import React from 'react'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { FaqAccordion } from '@/organisms/FaqAccordion'
import { Faq } from '@/services/FaqService'

interface FaqSectionProps {
  faqs: Faq[]
}

export const FaqSection: React.FC<FaqSectionProps> = ({ faqs }) => {
  if (!faqs) return null

  return (
    <>
      {faqs && faqs?.length && faqs.length > 0 && (
        <section role="complementary" className="relative flex w-full justify-center bg-black px-8 py-10 md:py-40">
          <div className="relative w-full max-w-[860px]">
            <PaddedContainer>{faqs && <FaqAccordion faqs={faqs} />}</PaddedContainer>
          </div>
        </section>
      )}
    </>
  )
}
